import React, { Component } from 'react';
// import { getChildren } from '../../utils/constant';
// // import { Text } from '../../components';

// const getConfig = (props) => {
//   const { text, size = 'huge', color = '#000', justifyContent = 'center', padding= 10, height= 40 } = props;
//   const config = [
//     {
//       name: "Text",
//       props: {
//         size: size,
//         text: text,
//         color: color,
//         width: '100%',
//         display: 'flex',
//         alignItems:'center',
//         height: `${height}px`,
//         justifyContent: justifyContent,
//         paddingLeft: justifyContent === 'flex-start' ? `${padding}px` : '0',
//         paddingRight: justifyContent === 'flex-end' ? `${padding}px` : '0',
//       }
//     }
//   ];
//   return config;
// }
export default class Title extends Component {

  render() {
    const {id, style} = this.props
    const customAttributes = {
      id, style
    };
    return (
      <div {...customAttributes}>{this.props.children}</div>
    );
  };
}
